import Header from "../includes/header";

export default class Dependencies {

	static BASE_PATH = `${window.config.themeDirectory}/node_modules/`;

	static libraries = {
		alpine:				Dependencies.BASE_PATH + 'alpinejs/dist/cdn.min.js',
		bootstrap:			Dependencies.BASE_PATH + 'bootstrap/dist/js/bootstrap.bundle.min.js',
		googleMaps:			`https://maps.googleapis.com/maps/api/js?key=${window.config.googleMapsApiKey}`,
		lazysizes:			Dependencies.BASE_PATH + 'lazysizes/lazysizes.min.js',
		luminous:			Dependencies.BASE_PATH + 'luminous-lightbox/dist/luminous.min.js',
		mailchimp:			'https://s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js',
		pikaday: 			Dependencies.BASE_PATH + 'pikaday/pikaday.js',
		recaptcha:			'https://www.google.com/recaptcha/api.js',
		splide:				Dependencies.BASE_PATH + '@splidejs/splide/dist/js/splide.min.js',
		snazzyInfoWindow: 	Dependencies.BASE_PATH + 'snazzy-info-window/dist/snazzy-info-window.min.js',
		vimeo:				Dependencies.BASE_PATH + '@vimeo/player/dist/player.min.js',
		youtube:			'https://www.youtube.com/iframe_api',
		revinate:			'https://contact-api.inguest.com/bundles/revinatecontactapi/js/revinate-form.js?v=1',
		jQuery:             Dependencies.BASE_PATH + 'jquery/dist/jquery.min.js',
		slick:				Dependencies.BASE_PATH + 'slick-carousel/slick/slick.min.js'
	};

}
